<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 30 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.9482 7.42896L7.80611 21.5711"
            :stroke="strokeColor"
            stroke-width="1.5"
        />
        <path
            d="M21.9482 21.571L7.80611 7.42891"
            :stroke="strokeColor"
            stroke-width="1.5"
        />
    </svg>
</template>
<script>
export default {
    name: 'CloseIcon',
    props: {
        height: {
            type: Number,
            default: 29
        },
        width: {
            type: Number,
            default: 30
        },
        strokeColor: {
            type: String,
            default: 'white'
        }
    }
}
</script>
